
export function getDateLabel(javascriptTimeStamp = 'invalid') {
  const date = new Date(javascriptTimeStamp)
  let label = ''
  if (date.toString() !== 'Invalid Date') {
    label = date.toLocaleDateString(undefined, {timeZone: 'UTC'})
  }
  return label
}
